import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const scrollTo = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
};

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.nav
      data-testid="top-nav"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50"
      style={{
        background: scrolled ? 'rgba(0,0,0,0.98)' : 'transparent',
        borderBottom: scrolled ? '1px solid rgba(255,255,255,0.08)' : 'none',
        transition: 'background 0.3s ease, border-color 0.3s ease',
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="transition-opacity hover:opacity-70"
            style={{ fontFamily: 'DM Sans', fontSize: '13px', fontWeight: 600, letterSpacing: '0.5px' }}
          >
            <span style={{ color: '#FFFFFF' }}>TREP</span>
            <span style={{ color: '#1E40AF' }}>TRADING</span>
            <span style={{ color: '#FFFFFF' }}>TECHNOLOGIES</span>
          </button>

          <button
            onClick={() => scrollTo('about')}
            data-testid="top-nav-link"
            className="text-sm"
            style={{
              color: '#9CA3AF',
              fontFamily: 'DM Sans',
              fontWeight: 500,
              transition: 'color 0.18s ease',
            }}
            onMouseEnter={e => (e.currentTarget.style.color = '#FFFFFF')}
            onMouseLeave={e => (e.currentTarget.style.color = '#9CA3AF')}
          >
            About
          </button>
        </div>
      </div>
    </motion.nav>
  );
};
